import fetch from '@/utils/fetch';
import * as types from './mutation_types';

export const create = ({ commit }, values) => {
  commit(types.AGENT_CREATE_SET_ERROR, '');
  commit(types.AGENT_CREATE_TOGGLE_LOADING);

  return fetch({ method: 'POST', url: 'users', data: values })
    .then((response) => {
      commit(types.AGENT_CREATE_TOGGLE_LOADING);

      return response.data;
    })
    .then((data) => {
      commit(types.AGENT_CREATE_SET_CREATED, data['data']);
    })
    .catch((e) => {
      commit(types.AGENT_CREATE_TOGGLE_LOADING);



      commit(types.AGENT_CREATE_SET_ERROR, e.message);
      throw e;
    });
};

export const reset = ({ commit }) => {
  commit(types.AGENT_CREATE_RESET);
};
